
import axios from 'axios';

export default {
    //key:'', // 用于 push url 生成
    //sk:'',
    //qrid:null,
    userid:null,
    access_token:null,
    //roles:[],
    qr:{
      key:"", // 二维码的 key 
      sk:"",  // 二维码的 sk
      pgkey:"",  // 页面的 pgkey
      status:-1,
      qrjson:{},
      type:0,
      srid:null,
      roles:[]
    },
    qrlanguage:null, // qrcode 的语言设置对象
    trademark:true, // 默认显示 trademark
    router:null,
    entry:true,
    device:1,
    form_valid:true,
    submit_btn:null,
    submitting:false,
    form_data:[],
    DEVICE_ANDROID:1,
    DEVICE_IOS:2,
    DEVICE_IPAD:3,
    DEVICE_OTHER:4,
    HOST:'https://ws.qr-code-generator.top',
    TITLE:'TOP QR',
    E88:1,
    I18N:2,
    version: 1, //this.E88,
    sys_version:null,
    app_class:'',
    app_style:{},
    app_top:true,
    video_play_page:false,
    //HOST:'https://ws.88erweima.top',
    //TITLE:'88 二维码',
    TYPE_TARGET_URL:1,
    TYPE_TARGET_WECHAT_MINIAPP:2,
    TYPE_TARGET_TEL:3,
    TYPE_TARGET_EMAIL:4,
    TYPE_TARGET_PAGE:5,
    TYPE_TARGET_FORM:6,
    TYPE_TARGET_LOCATION:7,
    PG_COMPONENT_HTML:1, // 包含标题、分割线和正文

    PG_COMPONENT_RICHTEXT:2, // 富文本

    PG_COMPONENT_ALBUM:3, // 照片

    PG_COMPONENT_FILE:4, // 文件

    PG_COMPONENT_CONTACT:5, // 联系方式

    PG_COMPONENT_AUDIO_VIDEO:6, // 音频视频

    FORM_CONTROL_INPUT:7, // 单文本输入

    FORM_CONTROL_MULTILINE_INPUT:8, // 多文本输入

    FORM_CONTROL_NUMERIC_INPUT:9, // 数字输入

    FORM_CONTROL_DATE_INPUT:10, // 日期输入

    FORM_CONTROL_TIME_INPUT:11, // 时间输入

    FORM_CONTROL_RADIO_INPUT:12, // 单选输入

    FORM_CONTROL_CHECKBOX_INPUT:13, // 多选输入

    FORM_CONTROL_CHECKLIST_INPUT:14, // 检查项

    FORM_CONTROL_LOCATION_INPUT:15, // 定位

    FORM_CONTROL_ADDRESS_INPUT:16, // 定制

    FORM_CONTROL_SIGNATURE_INPUT:17, // 签名

    FORM_CONTROL_PICS_INPUT:18, // 上传图片

    FORM_CONTROL_WECHAT_INPUT:19, // 微信名

    FORM_CONTROL_ID_INPUT:20, // 身份证号

    FORM_CONTROL_MOBILE_INPUT:21, // 手机号码

    FORM_CONTROL_CHEPAI_INPUT:22, // 车牌

    PG_COMPONENT_NAV_BTN:23, // 导航按钮

    PG_COMPONENT_NAV_LIST:24, // 导航列表

    PG_COMPONENT_NAV_CARD:25, // 导航卡片

    PG_COMPONENT_TABLE:26, // 表格

    FORM_CONTROL_SUBMIT:27, // 提交按钮

    FORM_CONTROL_VIDEO_INPUT:28, // 录像

    FORM_CONTROL_FILE_INPUT:29, // 文件上传

    FORM_CONTROL_GENDER_INPUT:30, // 性别输入

    FORM_CONTROL_GONGHAO_INPUT:31, // 工号输入

    FORM_CONTROL_AUDIO_INPUT:32, // 录音输入

    FORM_CONTROL_TABLE_INPUT:33, // 表格输入

    FORM_CONTROL_DUOJI_INPUT:34, // 多级输入

    FORM_CONTROL_NAME_INPUT:35, // 姓名

    DATA_CONTROL_FIELD:36, // 字段数据

    DATA_CONTROL_RECORD:37, // 记录数据

    DATA_CONTROL_WORKFLOW:38, // 任务流

    DATA_CONTROL_ANALYSIS:39, // 数据分析

    FORM_CONTROL_RATING_INPUT:40,

    PG_COMPONENT_AUDIO_PLAYER:41,

    PG_COMPONENT_CONTAINER:42, // 容器
  
    PG_COMPONENT_ADD2CONTACT:43,

    languages:{
      en:'English',
      hans:'简体中文',
      hant:'繁體中文',
      yue:'粵語（繁體中文）',
      fr:'Français',
      sp:'Español',
      pt:'Português',
      ru:'Русский',
      de:'Deutsch',
      ja:'日本語',
      ko:'한국어',
      ar:'َللُّغَةُ اَلْعَرَبِيَّة',
      cs:'čeština',
      da:'Dansk',
      el:'Ελληνικά',
      fa:'فارسی',
      fi:'Suomi',
      hi:'हिंदी',
      hu:'Magyar',
      it:'Italiano',
      no:'Norsk',
      nl:'Nederlands',
      pl:'Polski',
      ro:'Română',
      sv:'Svensk',
      uk:'Українська',
      vi:'Tiếng Việt',
      af:'Boole',
      az:'Azərbaycanca',
      be:'Беларуская',
      bg:'български',
      bs:'Bosanski',
      ca:'Català',
      et:'Eestlane',
      he:'עִברִית',
      hy:'հայերեն',
      id:'Indonesia',
      ka:'ქართული',
      kk:'Қазақша',
      lt:'Lietuvių',
      lv:'Latvietis',
      ms:'Malay',
      sk:'Slovenský',
      sl:'Slovenščina',
      sr:'Српски',
      tg:'Тоҷикӣ',
      th:'ไทย',
      tr:'Türkçe',
      uz:"O'zbek",
      bo:"བོད་སྐད།", // 藏语
      mn:"ᠮᠣᠩᠭᠣᠯ ᠬᠡᠯᠡ།", // 蒙语
      ug:"ئۇيغۇر تىلى ", // 维吾尔语
      mww:"Hmoob" // 苗语
    },

    generateStyle(style){

      if(!style)
        return null;
  
      const pmStyle=this.generatePmStyle(style.quick.pm);
  
      const bgStyle=this.generateBgStyle(style.quick.bg);
  
      const sizeStyle=this.generateSizeStyle(style.quick.size);
  
      const borerStyle=this.generateBorderStyle(style.quick.border);
  
      const miscStyle=this.generateMiscStyle(style.quick.misc);
  
      const cssStyle=this.cssStr2Json(style.css);
  
      const styleJson={ ...pmStyle, ...bgStyle, ...sizeStyle, ...borerStyle, ...miscStyle, ...cssStyle };
  
      return styleJson;
  
    },
    generatePmStyle(pm){
  
      if(!pm)
        return {};
  
      return {
              "padding-left":pm.paddings.padding_left+'px',
              "padding-right":pm.paddings.padding_right+'px',
              "padding-top":pm.paddings.padding_top+'px',
              "padding-bottom":pm.paddings.padding_bottom+'px',
              "margin-bottom":pm.margins.margin_bottom+'px',
              "margin-left":pm.margins.margin_left+'px',
              "margin-top":pm.margins.margin_top+'px',
              "margin-right":pm.margins.margin_right+'px'
            }
  
    },
    generateBgStyle(bg){

      const BG_COLOR=1;

      const BG_IMG=2;

      const MODE_COLOR=2;

      const NORMAL_MODE=1;

      const REPEAT_MODE=2;

      const STRETCH_MODE_X=3;
      
      const STRETCH_MODE_Y=4;

      const STRETCH_MODE_BOTH=5;

      const MEDIA_STATIC=1;

      const MEDIA_VARIABLE=2;

      if(!bg)
        return {};
  
      let bgstyle={};
  
      if(bg.mode==BG_COLOR&&bg.color_img.opaque==MODE_COLOR)
          bgstyle['background-color']=bg.color_img.color;
  
      if(bg.mode==BG_IMG){
  
        const bgimg=bg.color_img;
  
        if(bgimg.static_variable){
  
          if(bgimg.static_variable.type==MEDIA_STATIC)
            bgstyle['background']='url('+this.HOST+'/resources/'+bgimg.static_variable.file.filename+')'
  
          if(bgimg.static_variable.type==MEDIA_VARIABLE)
            bgstyle['background']='url('+this.HOST+'/resources/assets/images/variable.jpg)'
  
          if(bgimg.size==NORMAL_MODE)
            bgstyle['background-repeat']='no-repeat';  
  
          if(bgimg.size==REPEAT_MODE)
            bgstyle['background-repeat']='repeat';
  
          if(bgimg.size==STRETCH_MODE_X)
          {
  
            bgstyle['background-size']='100% auto';
  
            bgstyle['background-repeat-y']='no-repeat'; 
  
          }
  
          if(bgimg.size==STRETCH_MODE_Y)
          {
            
            bgstyle['background-size']='auto 100%';
  
            bgstyle['background-repeat-x']='no-repeat'; 
  
          }
  
          if(bgimg.size==STRETCH_MODE_BOTH)
            bgstyle['background-size']='100% 100%';
  
        }
  
      }
  
      return bgstyle;
  
    }, 
    cssStr2Json(css){

      if(!css||css=='')
        return {};

      let styleJson={};

      const pairs=css.split(';');

      let pair;

      for(var i=0; i<pairs.length; i++){

        pair=pairs[i].split(':');

        if(pair.length==2)
          styleJson[pair[0]]=pair[1];

      }

      return styleJson;

    },
    generateBorderStyle(border){
  
      if(!border)
        return {};
  
      return {
            'border-width':border.border_width+'px',
            'border-radius':border.border_radius+'px',
            'border-color':border.border_color,
            'border-style':border.border_style
      };
  
    },
    generateSizeStyle(size){
  
      if(!size)
        return {};
  
      return {
            'width.px':size.width,
            'height.px':size.height
      };
  
    },
    generateMiscStyle(misc){
  
      if(!misc)
        return {};
  
      let miscStyle={};
  
      if(misc.shadow)
        miscStyle={'box-shadow': '0 8px 20px 0px rgb(0 0 0 / 6%), 0 1px 8px rgb(0 0 0 / 4%)'};
  
      return miscStyle;
  
    }, 
    generateLayoutStyle(layout){

      if(!layout)
        return {};

      return {
              "display":"fex",
              "flex-direction":layout.direction,
              "justify-content":layout.justify,
              "align-items":layout.align
            }

    },
    replaceParms(template,parms){

        if(parms!=null){
    
            let jsonParms = JSON.parse(parms);
    
            for(var i=0; i<jsonParms.length;i++){
    
                const regex = new RegExp("【"+jsonParms[i].name+"】", 'g');
    
                template=template.replace(regex,jsonParms[i].value);
    
            }
        }
        
        return template;
    
    },
    removeExtension(file){
      
        let filemisc = JSON.parse(file.misc);
    
        let filename=filemisc.name;

        const dot_pos=filename.lastIndexOf('.');

        if(dot_pos==-1)
          return filename;
        else
          return filename.substring(0,dot_pos);

    },
    realFilename(file){

        let filemisc = JSON.parse(file.misc);
    
        return filemisc.name;
    
    },
    fileSize(file){
    
          let filesize=file.filesize;
        
            if(filesize>=1024*1024*1024)
                return Math.round(filesize/(1024*1024*1024))+' GB';
            else if(filesize>=1024*1024)
                return Math.round(filesize/(1024*1024))+' MB';
            else if(filesize>=1024)
                return Math.round(filesize/(1024))+' KB';
            else
                return filesize+' B';	  
    
    },
    gotoLink(router,navigatetargetrules){// redirect -- true, entry
  
        const TARGET_PAGE=1;
  
        const TARGET_URL=2;
  
        const TARGET_WECHAT_MINIAPP=3;
  
        const TARGET_TEL=4;
  
        const TARGET_EMAIL=5;
  
        //const TARGET_LOCATION=6;
  
        const navigatetarget=this.navigateTarget(navigatetargetrules);

        if(navigatetarget==-1)
        {

          this.router=router;

          this.login_redirect=navigatetargetrules;

          this.entry=false;

          return;

        }
        
        if(navigatetarget.type==TARGET_URL){
  
            window.location.href=navigatetarget.value;
          
        }
        else if(navigatetarget.type==TARGET_TEL){
  
            window.location.href='tel:'+navigatetarget.value;
            
        }
        else if(navigatetarget.type==TARGET_EMAIL){
  
            window.location.href='mailto:'+navigatetarget.value;
  
        }
        else if(navigatetarget.type==TARGET_PAGE){

            router.push({path:'/', query:{k:this.qr.key, s:this.qr.sk, p:navigatetarget.value}});

        }
        else if(navigatetarget.type==TARGET_WECHAT_MINIAPP){

            const msg=this.$t('message.scan_with_wechat');
  
            this.$toast.add({severity:'error', summary: this.TITLE, detail:msg, life: 3000});
  
        }
  
    },
    navigateTarget(navigatetargetrules){ // 包含页面、网址、邮箱、电话等

        const rules=navigatetargetrules;
  
        for(var i=0; i<rules.length;i++){

          if((rules[i].type==1||rules[i].type==2)&&!this.userid&&this.LOGIN_REQUIRED==0) //用户或游客
          {

              this.LOGIN_REQUIRED=1;

              return -1;

          }  
  
          if(rules[i].type==1&&rules[i].value==this.userid) // userid
            return rules[i].target;
  
          if(rules[i].type==2&&this.roles.includes(rules[i].value)) // userole
            return rules[i].target;
  
          if(rules[i].type==3) // daterange
          {
  
            const now = new Date();
  
            let fromatch=true;
  
            let tomatch=true;
  
            if(rules[i].value[0]!=null&&rules[i].value[0].trim().length>0){
  
              const from = new Date(rules[i].value[0]);
  
              if(now<from)
                fromatch=false;
  
            }
  
            if(rules[i].value[1]!=null&&rules[i].value[1].trim().length>0){
  
              const to = new Date(rules[i].value[1]);
  
              if(now>to)
                tomatch=false;
  
            }
            
            if(fromatch&&tomatch)
              return rules[i].target;
  
          }
          
          if(rules[i].type==4) // timerange
          {
  
            const now = new Date();
  
            const today= now.getFullYear()+'-'+now.getMonth()+'-'+now.getDay()+' ';
  
            let fromatch=true;
  
            let tomatch=true;
  
            if(rules[i].value[0]!=null&&rules[i].value[0].trim().length>0){
  
              const from = new Date(today+rules[i].value[0]);
  
              if(now<from)
                fromatch=false;
  
            }
  
            if(rules[i].value[1]!=null&&rules[i].value[1].trim().length>0){
  
              const to = new Date(today+rules[i].value[1]);
  
              if(now>to)
                tomatch=false;
  
            }
            
            if(fromatch&&tomatch)
              return rules[i].target;
  
          }

          if(rules[i].type==5) // device
          {

            if(rules[i].value==this.$common.device)
              return rules[i].target;
              
          }
  
        }
  
        return navigatetargetrules.default;
  
    },
    generateControlStyle(styleJson){

        //if(!styleJson.show)
        //  return "";
      
        var style="";
      
        if(styleJson.background_color!=""){
          style+="background-color:"+styleJson.background_color+";";
        }
      
        if(styleJson.shadow){
          style+="box-shadow: 0 8px 20px 0px rgb(0 0 0 / 6%), 0 1px 8px rgb(0 0 0 / 4%);";
        }
      
        if(styleJson.apply_border)
          {
            style+="border-width:"+styleJson.border_width+"px;";
      
            style+="border-style:"+styleJson.border_type+"px;";
      
            style+="border-color:"+styleJson.border_color+";";
      
          }
      
          if(styleJson.apply_round_corner){
            style+="border-radius:"+styleJson.border_radius+"px;";
          }
      
          style+="padding-left:"+styleJson.paddings.padding_left+"px;"
                +"padding-right:"+styleJson.paddings.padding_right+"px;"
                +"padding-top:"+styleJson.paddings.padding_top+"px;"
                +"padding-bottom:"+styleJson.paddings.padding_bottom+"px;"
                +"margin-bottom:"+styleJson.margins.margin_bottom+"px;"
                +"margin-left:"+styleJson.margins.margin_left+"px;"
                +"margin-top:"+styleJson.margins.margin_top+"px;"
                +"margin-right:"+styleJson.margins.margin_right+"px;";    
      
          return style;
      
    },  
    generateKey(){

        let chars=['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];//,'0','1','2','3','4','5','6','7','8','9'];
    
        var key="";

        for(var i=0; i<5;i++){
        key+=chars[Math.floor(Math.random()*chars.length)];
        }

        return key;

    },
    generalStyle(styleJson){

        let styleStr="";
    
        for (var key in styleJson) {
    
            styleStr+=key.replace("_","-") + ':' + styleJson[key]+";";
    
        }
    
        return styleStr;
    
    },
    stripHtml(html) {

      return html.replace( /(<([^>]+)>)/ig, '');
    
    },
    checkAccess(access_control){

      if(access_control.user.blacklist.includes(this.userid))
        return false;
      else{

        for(var i=0; i<this.roles.length; i++)
          if(access_control.role.blacklist.includes(this.roles[i]))
            return false;
        
        if(access_control.default_allow||access_control.user.whitelist.includes(this.userid))
          return true;

        for(var j=0;j<this.roles.length; j++)
          if(access_control.role.whitelist.includes(this.roles[j]))
            return true;
        
        return false;

      }
      
    },
    message(title,body){

      this.$confirm.require({
        message: body,
        header: title,
        icon: 'pi pi-exclamation-triangle'
      });

    },
    detectDevice(){

      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) 

          this.device=this.DEVICE_ANDROID;

      
      else if (/iPad/.test(userAgent) && !window.MSStream) 
          
          this.device=this.DEVICE_IPAD;
      
      else if (/iPhone|iPod/.test(userAgent) && !window.MSStream) 
        
          this.device=this.DEVICE_IOS;
    
      else
          this.device=this.DEVICE_OTHER;

    },
    playMedia(player, media_id, srid){ // mode=1 播放， mode=0 生成 play url
    
      const safeUrl=this.HOST+"/traffic/safeurl.html";
    
      axios.post(safeUrl,
                  {id:media_id, srid:srid, channel:2}
                  ).then((response)=>{
    
          
                  const status=response.data.status;
    
                  if(status==1)    
                    player.src = response.data.url;
                  else
                    player.src='status'+status.toString();            
                  
        }).
        catch(()=>{
          
        })
    
    },
    confirmPlay(url){

      const playUrl=this.HOST+"/traffic/play.html";
    
      axios.post(playUrl,
                {url:url}
         ).then(()=>{

          
          

        }).
        catch(()=>{

        });

    }    
}